// import { hot } from 'react-hot-loader';
import React from 'react';
import Application from './Application';
import logErrorToMyService from './helpers/logErrorToMyService';

class MainApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log('DERIVED: ', error);
    // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Можно также сохранить информацию об ошибке в соответствующую службу журнала ошибок
    logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) return <div className="errorWindow"><button onClick={() => window.location.reload()}>Reload</button></div>;
    return <Application />;
  }
}

export default MainApp;
